<template>
  <div class="emoji">
    <ul>
      <li v-for="(item, index) in state.emojiData">
        <span @click.stop="selectItem(index)" class="emojiSize">
          {{ item.char }}
        </span>
      </li>
    </ul>

    <span class="delEmoji" @click.stop="delEmoji">
      <img src="../../../assets/chat/chat_input_delEmoji.png" alt="" />
    </span>
  </div>
</template>
<script>
import { reactive, defineEmits } from "vue";
import { useStore } from "vuex";
import { onMounted } from "vue";
let emit = defineEmits(["getValue"]);

export default {
  name: "emoji",
  setup(props, { emit }) {
    const data = require("../../../assets/emoji/emoji.json");
    const store = useStore();
    const state = reactive({
      emojiData: data,
      activeIndex: 0,
      inputValue: "",
    });
    const changeActive = (index) => {
      state.activeIndex = index;
    };
    const getPureName = (name) => {
      return name.replace(/:/g, "");
    };
    const selectItem = (item) => {
      // store.commit('setEmoji',emoji)
      // console.log('选中的表情名称-----------------',data[item].char)
      // 将选中的表情添加到输入框
      // state.inputValue +=data[item].char

      emit("getValue", data[item].char);
    };
    const emojis = () => {
      return state.pannels.map((item) => {
        return Object.keys(state.emojiData[item]);
      });
    };

    // const handleEmoji = (item,index) => {
    //   console.log('表情名称-----------------',item)
    //   console.log('表情索引-----------------',index)
    //   selectItem(index)
    // }
    const handleInput = (e) => {
      // console.log('输入框的值-----------------',e.target.value)
      state.inputValue = e.target.value;
    };

    onMounted(() => {
      // console.log('表情数据-----------',data)
    });
    const delEmoji = () => {
      emit("delEmoji");
    };
    return {
      state,
      data,
      changeActive,
      getPureName,
      selectItem,
      emojis,
      handleInput,
      delEmoji,
    };
  },
};
</script>

<style scoped>
.emoji {
  height: 400px;
  /* height: 50vh; */
  width: 100%;
  overflow: auto;
}
.emoji ul {
  display: flex;
  flex-wrap: wrap;
  overflow: auto;
  padding-left: 25px;
  overflow-x: hidden;
}
.emoji ul li {
  /* margin-left: 40px; */
  display: flex;
  align-items: center;
  justify-content: center;
  padding-top: 20px;
}
.emojiSize {
  width: 94px;
  height: 64px;
  /* margin-left: 50px; */
  margin-bottom: 44px;
  scale: 2;
}
.delEmoji {
  position: fixed;
  bottom: 42px;
  right: 36px;
}
.delEmoji img {
  width: 74px;
  height: 76px;
}
</style>
